import { routes } from '~/app/routes';

/** Old paths that still resolve, with their query string kept. (`?detail=` links: `LEGACY_DETAIL` below.) */
export const REDIRECTS: { from: string; to: string }[] = [
  { from: '/ai/providers', to: routes.aiSettings('models') },
  { from: '/ai/settings/ai-providers', to: routes.aiSettings('models') },
  { from: '/ai/settings', to: routes.aiSettings('general') },
  { from: '/ai/config', to: routes.aiSettings('general') },
];

export interface LegacyDetailRow {
  /** The `<kind>` in `?detail=<kind>:<id>` / `?detail=new:<kind>`. */
  kind: string;
  record: (id: string) => string;
  create: string;
}

const flagRecord = (kind: string, section: string): LegacyDetailRow => ({
  kind,
  record: (id) => routes.featureFlagsRecord(section, id),
  create: routes.featureFlagsRecordNew(section),
});

const adminRecord = (kind: string, area: string): LegacyDetailRow => ({
  kind,
  record: (id) => routes.featureFlagsAdminRecord(area, id),
  create: routes.featureFlagsAdminRecordNew(area),
});

/** Only the feature flags tabs ever wrote `?detail=` (the MLS agreements drawers held local state); `key` (SDK keys) stays a transient viewer. */
export const LEGACY_DETAIL: LegacyDetailRow[] = [
  flagRecord('flag', 'flags'),
  flagRecord('update', 'updates'),
  flagRecord('request', 'requests'),
  flagRecord('user', 'users'),
  adminRecord('product', 'products'),
  adminRecord('environment', 'environments'),
  adminRecord('attribute', 'attributes'),
];

/** Where an old `?detail=` link now lives (other query keys kept, `detail` dropped), or null to leave it be. */
export function legacyDetailTarget(search: string): string | null {
  const params = new URLSearchParams(search);
  const detail = params.get('detail');
  if (!detail) return null;

  const [head, ...rest] = detail.split(':');
  const tail = rest.join(':');
  const isNew = head === 'new';
  const row = LEGACY_DETAIL.find((r) => r.kind === (isNew ? tail : head));
  if (!row || (!isNew && !tail)) return null;

  params.delete('detail');
  const query = params.toString();
  return `${isNew ? row.create : row.record(tail)}${query ? `?${query}` : ''}`;
}
